module.exports = __webpack_public_path__ + "static/media/hd-pg2.8705de9a.jpg";